import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";

@Injectable({
  providedIn: 'root'
})
export class UserInfosFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(onlyRgpd: boolean): Observable<FieldDefinition<any>[]> {
    const questions = [];
    if(!onlyRgpd) {
      questions.push(new FieldDefinition<string>({
        key: "infos",
        label: 'Informations complémentaires',
        type: 'textarea',
        order: 1
      }));
    }
    questions.push(new FieldDefinition<string>({
      key: "rgpd",
      label: 'En soumettant ce formulaire, j\'accepte que les informations saisies soient exploitées dans le cadre d\'une relation commerciale et technique avec Libriciel SCOP.',
      type: 'checkbox',
      required: true,
      order: 2
    }));

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
